import React, { useCallback, useRef, useState } from 'react';

import cx from './index.module.scss';

interface Props {
  onChange: (direction: Direction) => void;
  disabled?: boolean;
  disabledForAdjust?: boolean;
}

export type Direction = 'up' | 'down' | 'left' | 'right';

const PosAdjust: React.FC<Props> = ({ onChange, disabled = false, disabledForAdjust = false }) => {
  const [activeDir, setActiveDir] = useState<Direction>(null);
  const fixTouchCancelInterval = useRef(null);

  const setDir = useCallback(
    (dir: Direction) => () => {
      if (disabled) return;

      clearInterval(fixTouchCancelInterval.current);
      setActiveDir(dir);
    },
    [disabled]
  );

  const fixTouchCancel = useCallback(() => {
    clearInterval(fixTouchCancelInterval.current);

    fixTouchCancelInterval.current = setInterval(() => setActiveDir(null), 50);
  }, []);

  const handleOnTouchEnd = useCallback(
    (dir: Direction) => e => {
      if (disabled) return;

      setActiveDir(null);

      if (disabledForAdjust) return;
      onChange(dir);
    },
    [disabled, disabledForAdjust, onChange]
  );

  return (
    <div className={cx('pos-adjust', { disabled })}>
      <div className={cx('wrapper')}>
        <div className={cx('up-bg', { active: activeDir === 'up' })} />
        <div className={cx('down-bg', { active: activeDir === 'down' })} />
        <div className={cx('left-bg', { active: activeDir === 'left' })} />
        <div className={cx('right-bg', { active: activeDir === 'right' })} />
        <div
          className={cx('up')}
          id="up"
          onTouchStart={setDir('up')}
          onTouchEnd={handleOnTouchEnd('up')}
          onTouchCancel={() => fixTouchCancel()}
        />
        <div
          className={cx('down')}
          onTouchStart={setDir('down')}
          id="down"
          onTouchEnd={handleOnTouchEnd('down')}
          onTouchCancel={() => fixTouchCancel()}
        />
        <div
          className={cx('left')}
          onTouchStart={setDir('left')}
          id="left"
          onTouchEnd={handleOnTouchEnd('left')}
          onTouchCancel={() => fixTouchCancel()}
        />
        <div
          className={cx('right')}
          onTouchStart={setDir('right')}
          id="right"
          onTouchEnd={handleOnTouchEnd('right')}
          onTouchCancel={() => fixTouchCancel()}
        />
      </div>
    </div>
  );
};

export default PosAdjust;
